import { Helmet } from "react-helmet-async";

/**
 * Organization + WebSite JSON-LD (sitebreed).
 * Plaats één keer in `Layout.jsx` of in elke deep page is OK — Google dedup'eert.
 */
export function OrganizationJsonLd({ origin = "https://checkexpert.be" }) {
  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${origin}/#organization`,
    name: "CheckExpert",
    url: origin,
    logo: `${origin}/logo.png`,
    sameAs: [],
    contactPoint: [{
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "info@checkexpert.be",
      areaServed: ["BE", "NL"],
      availableLanguage: ["nl"],
    }],
    parentOrganization: {
      "@type": "Organization",
      name: "Webtron BV",
      vatID: "BE0793944703",
      address: {
        "@type": "PostalAddress",
        streetAddress: "A. Rodenbachwijk 12",
        addressLocality: "Waregem",
        postalCode: "8792",
        addressCountry: "BE",
      },
    },
  };
  const site = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${origin}/#website`,
    url: origin,
    name: "CheckExpert",
    publisher: { "@id": `${origin}/#organization` },
    inLanguage: ["nl-BE", "nl-NL"],
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(org)}</script>
      <script type="application/ld+json">{JSON.stringify(site)}</script>
    </Helmet>
  );
}

export function BreadcrumbJsonLd({ items, origin = "https://checkexpert.be" }) {
  // items: [{name, url}]
  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: it.name,
      item: it.url.startsWith("http") ? it.url : `${origin}${it.url}`,
    })),
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(ld)}</script>
    </Helmet>
  );
}

export function FaqJsonLd({ faqs }) {
  // faqs: [{q, short, long}]
  const ld = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: (faqs || []).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: `${f.short}${f.long ? " " + f.long : ""}`,
      },
    })),
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(ld)}</script>
    </Helmet>
  );
}

export function ServiceJsonLd({ name, description, slug, origin = "https://checkexpert.be" }) {
  const ld = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    provider: { "@id": `${origin}/#organization` },
    areaServed: [
      { "@type": "Country", name: "Belgium" },
      { "@type": "Country", name: "Netherlands" },
    ],
    description,
    offers: {
      "@type": "Offer",
      price: "4.99",
      priceCurrency: "EUR",
      availability: "https://schema.org/InStock",
      url: `${origin}/checks/${slug}`,
    },
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(ld)}</script>
    </Helmet>
  );
}
